import request from "@/utils/request";
import plaintextrequest from "@/utils/plaintextrequest";

// 登录
export function login(data) {
  return request({
    url: "/User/login",
    method: "post",
    data,
  });
}

// 用户信息
export function getinfo(data) {
  return request({
    url: "/User/getinfo",
    method: "post",
    data,
  });
}

// 请求手机验证码
export function getverfiy(data) {
  return request({
    url: "/user/code",
    method: "post",
    data,
  });
}

// 手机号登录
export function phoneLogin(data) {
  return request({
    url: "user/register",
    method: "post",
    data,
  });
}

// 注册设置密码
export function setpasswords(data) {
  // console.log(params)
  return request({
    url: "user/registerSetPass",
    method: "post",
    data,
  });
}
// 更新接口
export function versionCode(data) {
  return plaintextrequest({
    url: "/update/versionCode",
    method: "post",
    data,
  });
}
